import { createAction, props } from '@ngrx/store';
import { IClientSettings } from 'src/app/core/models/agency-settings.model';
import { DOCSADoc } from 'src/app/core/models/docsa.model';
import { EmergencyContactModel } from 'src/app/core/models/emergency-contact.model';
import { BrandZone } from 'src/app/core/models/fare-family.model';
import { ExchangeOptionFilter } from 'src/app/core/models/involuntary-change.model';
import { PnrInfo, QuoteRequest } from 'src/app/core/models/itinerary.model';
import { ContractError } from 'src/app/core/models/models';
import {
  FeedbackModelML,
  PenaltyFareBasis,
  PenaltyFareBasisMachineLearning,
  Price
} from 'src/app/core/models/cancellation.model';
import {
  ExchangeAvailability,
  ExchangeAvailabilityOption,
  ExchangeQuoteRequest,
  ExchangeSegment,
  IPricingRequestPayload,
  IVoluntaryReproState,
  VoluntaryExchangeQuote
} from 'src/app/core/models/voluntary-change.model';

export const clearVoluntaryChange = createAction('[Clear Voluntary change] Clear Voluntary change');

export const setLoadingVoluntaryChange = createAction(
  '[Voluntary Change Page] Set Loading In Voluntary change',
  props<{ isLoading: boolean }>()
);

export const ExchangePricingRequest = createAction(
  '[Voluntary Change Page] Exchange Pricing Request',
  props<{ payload: IPricingRequestPayload }>()
);

export const ExchangePricingSuccess = createAction(
  '[Voluntary Change Page] Exchange Pricing Success',
  props<{ exchangePricing: ExchangeAvailabilityOption }>()
);

export const ExchangePricingFail = createAction(
  '[Voluntary Change Page] Exchange Pricing Fail',
  props<{ error: ContractError }>()
);

export const GetExchangeTotalAmount = createAction(
  '[Voluntary Change Page] Get Exchange Total Amount'
);

export const UpdatePricingQuoteRequestWithSeatPrices = createAction(
  '[Voluntary Change Page] Update the pricing quote request with seat information',
  props<{ prices: Price[] }>()
);

export const LoadVoluntaryQuoteSuccess = createAction(
  '[Voluntary Change Page] Load Voluntary Quote Success',
  props<{
    voluntaryExchangeQuote: VoluntaryExchangeQuote;
    quote: QuoteRequest;
    isReissueActive: boolean;
    isAirline: boolean;
    isReissue?: boolean;
    redirectFromManual?: boolean;
  }>()
);

export const CameFromManualFlow = createAction('[Voluntary Change Page] Came From Manual Flow');

export const ReturnToManualFlow = createAction('[Voluntary Change Page] Return To Manual Flow');

export const LoadAvailability = createAction(
  '[Voluntary Change Page] Load Availability',
  props<{ form: ExchangeQuoteRequest; isVoluntary: boolean; needModel: boolean }>()
);

export const LoadAvailabilitySuccess = createAction(
  '[Voluntary Change Page] Load Availability Success',
  props<{ availabilities: ExchangeAvailability }>()
);

export const loadingPenaltiesRequest = createAction(
  '[Itinerary/Cancellation Page] Load penalgies request'
);

export const loadingPenaltiesMLRequest = createAction('[Voluntary Page] Load penalties ML request');

export const loadPenaltiesSuccess = createAction(
  '[Voluntary Page] Load Penalties Success',
  props<{ penaltyFareBasis: PenaltyFareBasis[] }>()
);

export const loadPenaltiesMLSuccess = createAction(
  '[Voluntary Page] Load Penalties ML success',
  props<{ penaltyMLFareBasis: PenaltyFareBasisMachineLearning }>()
);

export const LoadPenaltiesMLFail = createAction(
  '[Voluntary Page] Load Penalties ML Fail',
  props<{ error: ContractError }>()
);

export const LoadAvailabilityFail = createAction(
  '[Voluntary Change Page] Load Avaibility Fail',
  props<{ error: ContractError; isAirline: boolean; settings: IClientSettings }>()
);

export const ReturnToStep1 = createAction('[Voluntary Change Page] Return To Step1');

export const GoToSeatMap = createAction('[Voluntary Change Page] Go to Seat Map Step');

export const GoToConfirmation = createAction(
  '[Voluntary Change Page] Go to Confirmation Step',
  props<{ isAirline: boolean }>()
);

export const EmergencyContact = createAction(
  '[Voluntary Change Page] Emergency contact',
  props<{ contact: EmergencyContactModel[] }>()
);

export const SaveOption = createAction(
  '[Voluntary Change Page] Save Selected Option',
  props<{ option?: ExchangeAvailabilityOption; index: number }>()
);

export const GoToDocsa = createAction(
  '[Voluntary Change Page] Go to Docsa Step',
  props<{ isAirline: boolean }>()
);

export const DocsaSave = createAction(
  '[Voluntary Change Page] Docsa Save',
  props<{ docs: DOCSADoc[] }>()
);

export const DocsaRequest = createAction('[Voluntary Change Page] Docsa Request');

export const GoToSplitOrRequest = createAction(
  '[Voluntary Change Page] Go To Split or Request Step '
);

export const VoluntaryChangeRequest = createAction(
  '[Voluntary Change Page] Voluntary Change Request',
  props<{ isVoluntary: boolean }>()
);

export const VoluntaryChangeSuccess = createAction(
  '[Voluntary Change Page] Voluntary Change Success && Validate if docsa request',
  props<{ pnr: PnrInfo }>()
);

export const DocsaRequestSuccess = createAction('[Voluntary Change Page] Docsa Request Success');

export const VoluntaryChangeFail = createAction(
  '[Voluntary Change Page] Voluntary Change Fail',
  props<{ voluntaryChangeError: ContractError; docsaFail: boolean }>()
);

export const ContinueFromSplit = createAction('[Voluntary Change Page] Continue From Split');

export const ContinueFromAditionalInformation = createAction(
  '[Voluntary Change Page] Continue From Aditional Information'
);

export const GoBackFromSplit = createAction('[Voluntary Change Page] Can Cancel Split ?');

export const LoadFareFamiliesVoluntary = createAction(
  '[Voluntary Change Page] Load FareFamilies',
  props<{ option: ExchangeAvailabilityOption; index: number; open: boolean }>()
);

export const LoadFareFamiliesSuccess = createAction(
  '[Voluntary Change Page] Load FareFamilies Success',
  props<{ zones: BrandZone[] }>()
);

export const LoadFareFamiliesFail = createAction(
  '[Voluntary Change Page] Load FareFamilies Fail',
  props<{ error: ContractError }>()
);

export const AddComission = createAction(
  '[Voluntary Change Page] Add Comission',
  props<{ comission: number }>()
);

export const OpenCloseDetailModal = createAction(
  '[Voluntary Change Page] Open Detail Modal',
  props<{ open: boolean }>()
);

export const DoNothing = createAction('[Voluntary Change Page] Do Nothing');

export const SaveFarebasis = createAction(
  '[Voluntary Change Page] Save Farebasis on request',
  props<{ farebasis: string }>()
);

export const SaveFilter = createAction(
  '[Voluntary Change Page] Filter options',
  props<{ filter: ExchangeOptionFilter }>()
);

export const ResetNotExchangeAllowed = createAction(
  '[Voluntary Change Page] Reset NotExchangeAllowed'
);

export const SetAlternativeFlow = createAction(
  '[Voluntary Change Page] Set Alternative Flow Value',
  props<{ value: boolean }>()
);

export const SetIsNewFlow = createAction(
  '[Voluntary Change Page] Set Is New Flow Value',
  props<{ value: boolean }>()
);

export const sendFeedbackML = createAction(
  '[Voluntary Change Page] Machine Learning Feedback',
  props<{ feedback: FeedbackModelML }>()
);

export const sendFeedbackMLSuccess = createAction(
  '[Voluntary Change Page] Machine Learning Feedback success',
  props<{ result: string }>()
);

export const setRemoveSegments = createAction(
  '[Voluntary Change Page] Set Remove Segments',
  props<{ removeSegment: number }>()
);

export const restoreAllRemovedSegments = createAction(
  '[Voluntary Change Page] Restore all Removed Segments',
  props<{ segments: ExchangeSegment[] }>()
);

export const setIsOriginalFare = createAction(
  '[Voluntary Change Page] Set IsOriginalFare',
  props<{ isOriginalFare: boolean }>()
);

export const clearRemoveSegments = createAction('[Voluntary Change Page] Clear Remove Segments');

export const setVoluntaryReproState = createAction(
  '[Voluntary Change Page] Set VoluntaryReproState',
  props<{ voluntaryReproState: IVoluntaryReproState }>()
);

export const voluntaryReproStateRequestSuccess = createAction(
  '[Voluntary Change Page] Set VoluntaryReproState Success',
  props<{ voluntaryReproState: IVoluntaryReproState }>()
);

export const voluntaryReproStateRequestError = createAction(
  '[Voluntary Change Page] Set VoluntaryReproState Error',
  props<{ voluntaryReproState: IVoluntaryReproState }>()
);

export const dispatchFulfillConsult = createAction(
  '[Voluntary Change Page] Make fulfill request',
  props<{ quoteMap: any; remarks: any; paymentForm: any }>()
);

export const dispatchFulfillConsultSuccess = createAction(
  '[Voluntary Change Page] Make fulfill request success',
  props<{ fulfillAPIResponse: PnrInfo }>()
);

export const dispatchFulfillConsultError = createAction(
  '[Voluntary Change Page] Make fulfill request error'
);
